import { FormType } from '../../components/global-forms/GlobalForms.types';
import { UniDispatch, getState } from '../../store/types';
import { GlobalFormsActions } from './reducer';
import { FormSubscription } from './types';

let latestSubscriptionId = 0;
export function subscribeToFormCompletion(
  formType: FormType,
  onFormComplete: () => void,
) {
  return (dispatch: UniDispatch): FormSubscription => {
    const newSubscription = {
      id: latestSubscriptionId++,
      formType,
      onFormComplete,
    };
    dispatch(GlobalFormsActions.addSubscription(newSubscription));
    return newSubscription;
  };
}

export function notifyFormComplete(formType: FormType) {
  return (_dispatch: UniDispatch) => {
    const formsSubscriptions = getState().globalForms;
    const formTypeSubscriptions = formsSubscriptions[formType];
    if (formTypeSubscriptions) {
      formTypeSubscriptions.forEach((subscription) =>
        subscription.onFormComplete(),
      );
    }
  };
}
